<template>
  <aside
    class="pu-popover"
    :class="{ active: showPopover, desktop: $isDesktop }"
  >
    <button
      class="info-button"
      type="button"
      :aria-label="$t('More information...')"
      @click="togglePopover"
    >
      <slot name="trigger">
        <img
          loading="lazy"
          class="info-icon"
          src="@/assets/images/info.svg"
          width="21"
          height="21"
          alt=""
        />
      </slot>
    </button>

    <client-only>
      <portal v-if="showPopover" to="popover-target">
        <transition name="slide-fade" tag="div">
          <div class="popover-content">
            <button class="close-popover" @click="closePopover">
              <img
                loading="lazy"
                src="@/assets/images/close-x.svg"
                width="37"
                height="37"
                alt=""
              />
            </button>
            <slot name="content" :close-popover="closePopover">
              <div v-thtml="popoverContent" />
            </slot>
          </div>
        </transition>

        <template v-if="showPopover">
          <div class="pagemask" @click.self="closePopover" />
        </template>
      </portal>
    </client-only>
  </aside>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({})
class PuPopover extends Vue {
  showPopover: boolean = false

  @Prop({ type: String })
  popoverContent!: string

  togglePopover() {
    this.showPopover = !this.showPopover
  }

  closePopover() {
    this.showPopover = false
  }
}

export default toNative(PuPopover)
</script>

<style scoped>
.pu-popover {
  display: inline-block;
}

.active .info-button :deep(img) {
  opacity: 1;
}

.popover-content {
  font-size: var(--body);
  background: #fff;
  border-radius: 0.3em;
  border: 1px solid #ccc;
  box-shadow: 0 0.1em 0.1em rgba(0, 0, 0, 0.2);
  display: block;
  left: 0;
  margin: auto 2em;
  min-width: 15em;
  padding: 1em;
  position: fixed;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 14;
}

.close-popover {
  width: 2.5em;
  height: 2.5em;
  background: var(--colour-dark-blue);
  position: absolute;
  right: -1em;
  top: -1em;
  border-radius: 50%;
  opacity: 1;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border: none;
  box-shadow: none;
}

.close-popover:active {
  background: #222;
}

.close-popover img {
  width: 100%;
  pointer-events: none;
}

.info-button {
  display: inline-block;
  min-width: 1.4em;
  min-height: 1.4em;
  padding: 0;
  margin: 0;
  box-shadow: none;
  border: none;
  vertical-align: middle;
  background: transparent;
  cursor: pointer;
}

.info-button :deep(img) {
  opacity: 0.5;
  pointer-events: none;
}

.info-button:active {
  background: none;
  box-shadow: none;
  transform: none;
}

.info-button:active img {
  opacity: 0.75;
}

.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.1s ease-in;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(1em);
  opacity: 0;
}

/* desktop & tablet */
.desktop .popover-content {
  margin: auto;
  max-width: 38em;
  font-size: revert;
}

.pu-popover.desktop .info-button:hover img.info-icon,
.pu-popover.desktop .info-button:active img.info-icon,
.pu-popover.desktop .info-button:focus-visible img.info-icon {
  opacity: 0.75;
  outline: none;
  transform: scale(1.25);
  transition: transform 0.2s ease-out;
}
</style>
